/* Herring — herringshoes.co.uk · Shopify theme JS */

(function() {
  'use strict';

  // ── Money ─────────────────────────────────────────────
  function formatMoney(cents, currency) {
    var amount = (cents / 100) || 0;
    var code = currency || 'GBP';

    if (code === 'GBP') {
      return '£' + amount.toFixed(2);
    }

    try {
      return new Intl.NumberFormat(navigator.language || undefined, {
        style: 'currency',
        currency: code
      }).format(amount);
    } catch (e) {
      return amount.toFixed(2) + ' ' + code;
    }
  }

  // ── Cart ──────────────────────────────────────────────
  var EMPTY_HTML =
    '<div style="text-align:center;padding:80px 0;opacity:0.45">' +
      '<div class="eyebrow" style="margin-bottom:12px">Your bag is empty</div>' +
    '</div>';

  function escapeHtml(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function(c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function initShippingEstimators(root) {
    (root || document).querySelectorAll('[data-shipping-estimator]').forEach(function(estimator) {
      if (estimator.dataset.shippingEstimatorReady === 'true') return;
      estimator.dataset.shippingEstimatorReady = 'true';

      var country = estimator.querySelector('[data-shipping-country]');
      var postcode = estimator.querySelector('[data-shipping-postcode]');
      var province = estimator.querySelector('[data-shipping-province]');
      var submit = estimator.querySelector('[data-shipping-submit]');
      var result = estimator.querySelector('[data-shipping-result]');
      var deliveryNote = estimator.querySelector('[data-shipping-delivery-note]');
      var currency = estimator.getAttribute('data-shop-currency') || 'GBP';
      if (!country || !postcode || !submit || !result) return;

      // The snippet renders the selected country's copy server-side; these keep
      // it in step as the shopper changes country (and after a browser form
      // restore, where the restored selection can differ from the markup).
      function selectedCountryOption() {
        return country.options[country.selectedIndex] || null;
      }

      function updateDeliveryNote() {
        if (!deliveryNote) return;
        var option = selectedCountryOption();
        var tier = option ? option.getAttribute('data-delivery-tier') : null;
        if (!tier) return;
        var message = estimator.getAttribute('data-delivery-note-' + tier);
        if (message) deliveryNote.textContent = message;
      }

      // A blank province is a 422 for some countries and fine for others, so the
      // field says which it is for the country in hand.
      function updateProvinceField() {
        if (!province) return;
        var option = selectedCountryOption();
        if (!option) return;
        var placeholder = option.getAttribute('data-province-placeholder');
        if (placeholder) province.placeholder = placeholder;
        province.setAttribute('aria-required', option.getAttribute('data-province-required') === 'true' ? 'true' : 'false');
      }

      function syncCountryFields() {
        updateDeliveryNote();
        updateProvinceField();
      }

      // Shopify rejects an unusable address with 422 and field-keyed arrays of
      // ready-to-show copy, e.g. {"zip":["Enter a postcode"],"province":["Select
      // a state"]}. Surface that rather than a generic failure, and point the
      // shopper at the field that needs fixing.
      function describeFailure(error) {
        var fallback = {
          message: 'Delivery rates could not be calculated. Please check the address and try again.',
          field: null
        };
        if (!error || typeof error !== 'object' || error instanceof Error) return fallback;

        var fieldInputs = { zip: postcode, province: province };
        var messages = [];
        var field = null;

        Object.keys(error).forEach(function(key) {
          var entries = Array.isArray(error[key]) ? error[key] : [error[key]];
          entries.forEach(function(entry) {
            if (typeof entry !== 'string' || !entry.trim()) return;
            messages.push(entry.trim().replace(/\.$/, ''));
            if (!field) field = fieldInputs[key] || null;
          });
        });

        if (!messages.length) return fallback;
        return { message: messages.join('. ') + '.', field: field };
      }

      function formatRatePrice(value) {
        var amount = parseFloat(value);
        if (Number.isNaN(amount)) return value;
        if (currency === 'GBP') return '£' + amount.toFixed(2);
        try {
          return new Intl.NumberFormat(undefined, { style: 'currency', currency: currency }).format(amount);
        } catch (e) {
          return amount.toFixed(2) + ' ' + currency;
        }
      }

      function setResult(html, state) {
        result.className = 'shipping-estimator__result' + (state ? ' shipping-estimator__result--' + state : '');
        result.innerHTML = html;
      }

      function fetchRates() {
        var zip = postcode.value.trim();
        if (!zip) {
          postcode.focus();
          setResult('Enter a postcode to calculate delivery rates.', 'error');
          return;
        }

        var params = new URLSearchParams();
        params.set('shipping_address[country]', country.value);
        params.set('shipping_address[zip]', zip);
        if (province && province.value.trim()) {
          params.set('shipping_address[province]', province.value.trim());
        }

        submit.disabled = true;
        submit.textContent = 'Checking...';
        setResult('Checking available rates...', 'loading');

        fetch('/cart/shipping_rates.json?' + params.toString(), {
          headers: { 'Accept': 'application/json' }
        })
          .then(function(response) {
            return response.json().then(function(json) {
              if (!response.ok) throw json;
              return json;
            });
          })
          .then(function(json) {
            var rates = json.shipping_rates || [];
            if (!rates.length) {
              setResult('No delivery rates were returned for that address.', 'error');
              return;
            }

            setResult('<ul>' + rates.map(function(rate) {
              var name = rate.name || rate.source || 'Delivery';
              return '<li><span>' + escapeHtml(name) + '</span><strong>' + escapeHtml(formatRatePrice(rate.price)) + '</strong></li>';
            }).join('') + '</ul>', '');
          })
          .catch(function(error) {
            var failure = describeFailure(error);
            setResult(escapeHtml(failure.message), 'error');
            if (failure.field) failure.field.focus();
          })
          .finally(function() {
            submit.disabled = false;
            submit.textContent = 'Calculate';
          });
      }

      submit.addEventListener('click', fetchRates);
      country.addEventListener('change', syncCountryFields);
      syncCountryFields();
      [postcode, province].forEach(function(input) {
        if (!input) return;
        input.addEventListener('keydown', function(event) {
          if (event.key !== 'Enter') return;
          event.preventDefault();
          fetchRates();
        });
      });
    });
  }

  function renderCart(cart) {
    var bubble = document.getElementById('cart-count-bubble');
    var label  = document.getElementById('cart-count-label');
    var total  = document.getElementById('cart-total');
    var items  = document.getElementById('cart-items');
    var currency = cart.currency || 'GBP';

    if (bubble) {
      bubble.style.display = cart.item_count > 0 ? 'flex' : 'none';
      bubble.textContent = cart.item_count;
    }
    if (label) {
      label.textContent = cart.item_count + ' item' + (cart.item_count !== 1 ? 's' : '');
    }
    if (total) {
      total.textContent = formatMoney(cart.total_price, currency);
    }
    if (items) {
      if (cart.items.length === 0) {
        items.innerHTML = EMPTY_HTML;
      } else {
        function buildCartItemMarkup(item, itemDelayMsg) {
          var variant = item.variant_title && item.variant_title !== 'Default Title'
            ? escapeHtml(item.variant_title) : '';
          var img = item.image
            ? '<img src="' + escapeHtml(item.image) + '" alt="' + escapeHtml(item.product_title) + '" width="80" height="100">'
            : '<div style="width:80px;height:100px;background:var(--bone)"></div>';
          var delayMarkup = itemDelayMsg && String(itemDelayMsg).trim()
            ? '<div style="font-size:13px;opacity:0.55;margin-bottom:8px">' + escapeHtml(String(itemDelayMsg).trim()) + '</div>'
            : '';

          return '<div class="cart-item">' +
            img +
            '<div>' +
              '<div class="serif" style="font-size:18px;letter-spacing:-0.005em;margin-bottom:4px">' + escapeHtml(item.product_title) + '</div>' +
              '<div style="font-size:13px;opacity:0.55;margin-bottom:8px">' + variant + (item.quantity > 1 ? ' · Qty ' + item.quantity : '') + '</div>' +
              delayMarkup +
              '<div style="display:flex;justify-content:space-between;align-items:center">' +
                '<span class="serif" style="font-size:20px">' + formatMoney(item.final_line_price, currency) + '</span>' +
                '<button type="button" data-cart-remove="' + escapeHtml(item.key) + '" style="background:none;border:0;opacity:0.45;cursor:pointer;font-family:var(--mono);font-size:11px;letter-spacing:0.16em;text-transform:uppercase">Remove</button>' +
              '</div>' +
            '</div>' +
          '</div>';
        }

        var itemMarkupPromises = cart.items.map(function(item) {
          var variantId = item.variant_id || item.id;

          var url = 'https://herringshoes.co.uk/tools/hss-utils/ajaxHandler.php?task=getOOSMessage&variantId=' + encodeURIComponent(variantId);

          return fetch(url, {
            headers: { 'Accept': 'text/plain' }
          })
            .then(function(response) {
              if (!response.ok) return '';
              return response.text().then(function(text) {
                var normalized = String(text || '').trim();
                if (!normalized || normalized.toLowerCase().indexOf('this item will need to be') !== 0) {
                  return '';
                }
                return normalized;
              });
            })
            .then(function(text) {
              return buildCartItemMarkup(item, text);
            })
            .catch(function() {
              return buildCartItemMarkup(item, '');
            });
        });

        Promise.all(itemMarkupPromises).then(function(markups) {
          items.innerHTML = markups.join('') + '<div id="cart-upsell-slot"></div>';
          renderDrawerCareUpsell();
        });
      }
    }
  }

  // ── Care upsell variant selection ──────────────────────
  // Shared between the server-rendered strip (PDP, cart page, and — via a
  // cloned <template>, see renderDrawerCareUpsell — the cart drawer). Every
  // instance emits the same markup shape (a data-care-item wrapper with
  // per-option <select>s, an optional colour-swatch row, and a JSON variants
  // blob) so a colour/size choice always resolves to a real variant before
  // "Add" is used, instead of silently adding the default.
  function parseCareVariants(item) {
    var script = item.querySelector('script[data-care-variants]');
    if (!script) return [];
    try {
      return JSON.parse(script.textContent).map(function(v) {
        return {
          id: v.id,
          price: v.price,
          available: v.available,
          options: v.options || [v.option1, v.option2, v.option3].filter(function(o) { return o != null; })
        };
      });
    } catch (e) {
      return [];
    }
  }

  // Keyed by each select's own option-index rather than an array position:
  // a style-siblings item suppresses its single-value Colour <select> (the
  // swatch row replaces it), so the rendered selects can skip indices —
  // matching by position against the full variant.options array would then
  // compare the wrong fields.
  function careItemSelectedOptions(item) {
    var selected = {};
    item.querySelectorAll('[data-care-option-index]').forEach(function(sel) {
      selected[sel.getAttribute('data-care-option-index')] = sel.value;
    });
    return selected;
  }

  function updateCareItem(item) {
    var variants = parseCareVariants(item);
    var btn = item.querySelector('[data-care-add]');
    if (!variants.length || !btn) return;

    var selected = careItemSelectedOptions(item);
    var indices = Object.keys(selected);
    var variant = indices.length
      ? variants.find(function(v) { return indices.every(function(i) { return v.options[i] === selected[i]; }); })
      : variants[0];

    var priceEl = item.querySelector('[data-care-price]');
    if (!variant) {
      btn.removeAttribute('data-care-add');
      btn.disabled = true;
      btn.textContent = 'Unavailable';
      return;
    }
    btn.setAttribute('data-care-add', variant.id);
    if (priceEl) priceEl.textContent = formatMoney(variant.price);
    btn.disabled = !variant.available;
    btn.textContent = variant.available ? 'Add' : 'Out of stock';
  }

  document.addEventListener('change', function(e) {
    var sel = e.target.closest('[data-care-option-index]');
    if (!sel) return;
    var item = sel.closest('[data-care-item]');
    if (item) updateCareItem(item);
  });

  // Colour swatches — each colourway is its own product grouped by
  // herring_style_id (see care-upsell.liquid). Picking one swaps the tile's
  // image, remaining option selects, and variants blob in place via
  // /products/<handle>.js, rather than navigating away mid quick-add.
  function swapCareItemColour(item, handle) {
    fetch('/products/' + encodeURIComponent(handle) + '.js')
      .then(function(r) {
        if (!r.ok) throw new Error('not found');
        return r.json();
      })
      .then(function(p) {
        var optionCount = (p.options || []).length;
        var variants = (p.variants || []).map(function(v) {
          return {
            id: v.id,
            price: v.price,
            available: v.available,
            options: [v.option1, v.option2, v.option3].slice(0, optionCount)
          };
        });
        if (!variants.length) return;
        var cv = variants.find(function(v) { return v.available; }) || variants[0];

        var script = item.querySelector('script[data-care-variants]');
        if (script) script.textContent = JSON.stringify(variants);

        item.querySelectorAll('[data-care-option-index]').forEach(function(sel) {
          var idx = sel.getAttribute('data-care-option-index');
          var seen = {};
          var values = [];
          variants.forEach(function(v) {
            var val = v.options[idx];
            if (val != null && !seen[val]) { seen[val] = true; values.push(val); }
          });
          sel.innerHTML = values.map(function(val) {
            return '<option value="' + escapeHtml(val) + '"' + (cv.options[idx] === val ? ' selected' : '') + '>' + escapeHtml(val) + '</option>';
          }).join('');
        });

        var newUrl = '/products/' + p.handle;
        item.querySelectorAll('a[href]').forEach(function(a) { a.setAttribute('href', newUrl); });

        var wrap = item.querySelector('.care-upsell__imgwrap');
        if (wrap && p.featured_image) {
          var src = p.featured_image + (p.featured_image.indexOf('?') >= 0 ? '&' : '?') + 'width=240';
          wrap.innerHTML = '<img src="' + escapeHtml(src) + '" alt="" loading="lazy" width="120" height="120">';
        }

        updateCareItem(item);
      })
      .catch(function() {});
  }

  document.addEventListener('click', function(e) {
    var swatch = e.target.closest('[data-care-swatch]');
    if (swatch && !swatch.classList.contains('active')) {
      var item = swatch.closest('[data-care-item]');
      var handle = swatch.getAttribute('data-care-swatch');
      if (item && handle) {
        item.querySelectorAll('[data-care-swatch]').forEach(function(s) { s.classList.toggle('active', s === swatch); });
        swapCareItemColour(item, handle);
      }
    }
  });

  // The drawer's upsell strip is rendered server-side once (in header.liquid,
  // inside #care-upsell-drawer-template) rather than rebuilt from
  // /collections/.../products.json — that endpoint carries no metafields, so
  // it couldn't reach style_name or the sibling-colour data above. Every
  // drawer render just clones the template's current markup.
  function renderDrawerCareUpsell() {
    var slot = document.getElementById('cart-upsell-slot');
    var tpl = document.getElementById('care-upsell-drawer-template');
    if (!slot || !tpl) return;
    slot.innerHTML = '';
    slot.appendChild(tpl.content.cloneNode(true));
  }

  function refreshCart() {
    return fetch('/cart.js')
      .then(function(r) { return r.json(); })
      .then(function(cart) {
        renderCart(cart);
        return cart;
      })
      .catch(function() { /* network hiccup — keep current display */ });
  }

  function removeCartItem(key) {
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: 0 })
    })
    .then(function(r) { return r.json(); })
    .then(function(cart) { renderCart(cart); })
    .catch(function() { refreshCart(); });
  }

  function addToCart(variantId, quantity) {
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: Number(variantId), quantity: quantity || 1 })
    })
    .then(function(r) {
      if (!r.ok) return r.json().then(function(e) { throw e; });
      return r.json();
    })
    .then(function() { return refreshCart(); });
  }

  // Event delegation — survives drawer re-renders
  document.addEventListener('click', function(e) {
    var btn = e.target.closest('[data-cart-remove]');
    if (btn) {
      removeCartItem(btn.getAttribute('data-cart-remove'));
    }

    var careBtn = e.target.closest('[data-care-add]');
    if (careBtn && !careBtn.disabled) {
      var variantId = careBtn.getAttribute('data-care-add');
      careBtn.disabled = true;
      careBtn.textContent = '…';
      addToCart(variantId, 1)
        .then(function() {
          careBtn.textContent = 'Added ✓';
          if (typeof openCart === 'function') openCart();
        })
        .catch(function() {
          careBtn.disabled = false;
          careBtn.textContent = 'Add';
        });
    }
  });

  // ── Cart page ─────────────────────────────────────────
  // Full-page bag. Quantity steppers and remove links update via
  // /cart/change.js by line, then reload so the server-rendered
  // Liquid totals stay the source of truth. No-JS falls back to the
  // native form's "Update bag" button.
  function changeCartLine(line, quantity, row) {
    if (row) row.classList.add('is-updating');
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ line: Number(line), quantity: Number(quantity) })
    })
    .then(function(r) {
      if (!r.ok) throw new Error('change failed');
      return r.json();
    })
    .then(function() { window.location.reload(); })
    .catch(function() {
      if (row) row.classList.remove('is-updating');
    });
  }

  function initCartPage() {
    var page = document.querySelector('[data-cart-page]');
    if (!page) return;

    page.addEventListener('click', function(e) {
      var step = e.target.closest('[data-qty-change]');
      var remove = e.target.closest('[data-cart-remove-line]');
      var row;

      if (step) {
        row = step.closest('[data-cart-line]');
        var input = row && row.querySelector('[data-qty-input]');
        if (!input) return;
        var next = Math.max(0, (parseInt(input.value, 10) || 0) + parseInt(step.getAttribute('data-qty-change'), 10));
        changeCartLine(row.getAttribute('data-cart-line'), next, row);
      } else if (remove) {
        row = remove.closest('[data-cart-line]');
        changeCartLine(remove.getAttribute('data-cart-remove-line'), 0, row);
      }
    });

    page.addEventListener('change', function(e) {
      var input = e.target.closest('[data-qty-input]');
      if (!input) return;
      var row = input.closest('[data-cart-line]');
      var qty = Math.max(0, parseInt(input.value, 10) || 0);
      changeCartLine(row.getAttribute('data-cart-line'), qty, row);
    });
  }

  // Expose for inline handlers / PDP
  window.herringCart = {
    refresh: refreshCart,
    add: addToCart,
    remove: removeCartItem,
    formatMoney: formatMoney,
    initShippingEstimators: initShippingEstimators
  };

  initShippingEstimators();

  // ── Quick view ────────────────────────────────────────
  // Product-card "Quick view" → fetch /products/{handle}.js, render a
  // dialog with option pickers and add-to-bag wired to the cart drawer.
  var qvDialog = null;

  function qvEnsure() {
    if (qvDialog) return qvDialog;
    qvDialog = document.createElement('dialog');
    qvDialog.id = 'quick-view';
    qvDialog.addEventListener('click', function(e) {
      // Backdrop click — the dialog element itself is only hit outside .qv-grid
      if (e.target === qvDialog) qvDialog.close();
    });
    qvDialog.addEventListener('close', function() {
      // The close event is queued as a task — if the dialog has already
      // been reopened by the time it fires, leave the new content alone
      if (qvDialog.open) return;
      document.body.style.overflow = '';
      qvDialog.innerHTML = '';
    });
    document.body.appendChild(qvDialog);
    return qvDialog;
  }

  function qvImageUrl(src, width) {
    if (!src) return '';
    return src + (src.indexOf('?') >= 0 ? '&' : '?') + 'width=' + width;
  }

  function qvRender(p, url, displayTitle) {
    var dialog = qvEnsure();
    var title = displayTitle || p.title;

    // Selection seeded from the first available variant (else the first)
    var seed = null;
    for (var i = 0; i < p.variants.length; i++) {
      if (p.variants[i].available) { seed = p.variants[i]; break; }
    }
    if (!seed) seed = p.variants[0];
    var selected = seed.options.slice();
    var hasOnlyDefault = p.variants.length === 1 && seed.title === 'Default Title';

    // Distinct values per option, sizes sorted numerically
    var optionValues = p.options.map(function(opt, idx) {
      var seen = [];
      p.variants.forEach(function(v) {
        if (seen.indexOf(v.options[idx]) < 0) seen.push(v.options[idx]);
      });
      if (String(opt.name || opt).toLowerCase().indexOf('size') >= 0) {
        seen.sort(function(a, b) { return parseFloat(a) - parseFloat(b); });
      }
      return seen;
    });

    function findVariant() {
      return p.variants.find(function(v) {
        return v.options.every(function(o, i) { return o === selected[i]; });
      });
    }

    function valueAvailable(idx, value) {
      return p.variants.some(function(v) {
        if (v.options[idx] !== value || !v.available) return false;
        return v.options.every(function(o, i) { return i === idx || o === selected[i]; });
      });
    }

    // UK width fittings — size values like "10 F" carry the fit as a
    // trailing letter; group sizes per fitting when more than one exists
    var FIT_NAMES = { E: 'Narrow fit', F: 'Standard fit', G: 'Wide fit', H: 'Extra wide fit' };
    function sizeFit(value) {
      var m = String(value).match(/^(.+)\s+([A-Za-z]{1,2})$/);
      return m ? { size: m[1], fit: m[2].toUpperCase() } : null;
    }

    function optionsHtml() {
      if (hasOnlyDefault) return '';
      return p.options.map(function(opt, idx) {
        var name = String(opt.name || opt);
        var isSize = name.toLowerCase().indexOf('size') >= 0;

        function btnHtml(value, label) {
          var sel = value === selected[idx];
          var avail = valueAvailable(idx, value);
          var cls = isSize
            ? 'size-btn' + (sel ? ' selected' : '') + (avail ? '' : ' size-btn--oos')
            : 'filter-btn' + (sel ? ' active' : '');
          return '<button type="button" class="' + cls + '" data-qv-option="' + idx + '" data-qv-value="' + escapeHtml(value) + '">' + escapeHtml(label || value) + '</button>';
        }

        var body;
        var parsed = isSize ? optionValues[idx].map(sizeFit) : null;
        var fits = parsed && parsed.every(Boolean)
          ? parsed.map(function(f) { return f.fit; }).filter(function(f, i, a) { return a.indexOf(f) === i; }).sort()
          : [];
        if (fits.length > 1) {
          body = fits.map(function(fit, fi) {
            var btns = optionValues[idx].filter(function(value, vi) {
              return parsed[vi].fit === fit;
            }).map(function(value) {
              return btnHtml(value, sizeFit(value).size);
            }).join('');
            return '<div class="eyebrow" style="opacity:0.55;margin-bottom:10px;' + (fi > 0 ? 'margin-top:18px' : '') + '">' +
                escapeHtml(fit) + ' fitting' +
                (FIT_NAMES[fit] ? '<span style="opacity:0.7;text-transform:none;letter-spacing:0.05em"> — ' + FIT_NAMES[fit] + '</span>' : '') +
              '</div>' +
              '<div class="size-grid"' + (fi < fits.length - 1 ? ' style="margin-bottom:0"' : '') + '>' + btns + '</div>';
          }).join('');
        } else {
          var btns = optionValues[idx].map(function(value) { return btnHtml(value); }).join('');
          body = '<div class="' + (isSize ? 'size-grid' : '') + '"' + (isSize ? '' : ' style="display:flex;gap:8px;flex-wrap:wrap"') + '>' + btns + '</div>';
        }

        return '<div style="margin-bottom:20px">' +
          '<div class="eyebrow" style="opacity:0.55;margin-bottom:12px">' + escapeHtml(name) +
            '<span style="opacity:0.7;text-transform:none;letter-spacing:0.05em;margin-left:8px">' + escapeHtml(selected[idx]) + '</span>' +
          '</div>' +
          body +
        '</div>';
      }).join('');
    }

    function atbHtml() {
      var v = findVariant();
      if (!v) return '<button type="button" class="add-to-bag" data-qv-add disabled style="opacity:0.45;cursor:not-allowed">Unavailable in this combination</button>';
      if (!v.available) return '<button type="button" class="add-to-bag" data-qv-add disabled style="opacity:0.45;cursor:not-allowed">Out of stock</button>';
      return '<button type="button" class="add-to-bag" data-qv-add>Add to bag — ' + formatMoney(v.price) + '</button>';
    }

    function render() {
      var v = findVariant();
      var img = (v && v.featured_image && v.featured_image.src) || p.featured_image;
      var compare = p.compare_at_price > p.price
        ? '<span style="opacity:0.4;text-decoration:line-through;font-size:20px">' + formatMoney(p.compare_at_price) + '</span> '
        : '';
      dialog.innerHTML =
        '<div class="qv-grid">' +
          '<div class="qv-img">' +
            (img ? '<img src="' + escapeHtml(qvImageUrl(img, 900)) + '" alt="' + escapeHtml(title) + '" width="450" height="562">' : '') +
          '</div>' +
          '<div class="qv-info">' +
            (p.type ? '<div class="eyebrow" style="opacity:0.55;margin-bottom:10px">' + escapeHtml(p.type) + '</div>' : '') +
            '<div class="serif qv-title">' + escapeHtml(title) + '</div>' +
            '<div class="serif qv-price">' + compare + formatMoney(v ? v.price : p.price) + '</div>' +
            optionsHtml() +
            atbHtml() +
            '<div id="qv-error" style="display:none;color:var(--oxblood);font-size:13px;text-align:center;margin-top:10px"></div>' +
            '<a href="' + escapeHtml(url) + '" class="link-u eyebrow" style="display:block;text-align:center;opacity:0.55;margin-top:16px">Full details</a>' +
          '</div>' +
        '</div>' +
        '<button type="button" class="qv-close" data-qv-close aria-label="Close quick view">' +
          '<svg width="16" height="16" viewBox="0 0 16 16" fill="none"><path d="M2 2l12 12M14 2L2 14" stroke="currentColor" stroke-width="1.5"/></svg>' +
        '</button>';
    }

    dialog.onclick = function(e) {
      if (e.target === dialog) { dialog.close(); return; }
      if (e.target.closest('[data-qv-close]')) { dialog.close(); return; }

      var opt = e.target.closest('[data-qv-option]');
      if (opt) {
        selected[Number(opt.getAttribute('data-qv-option'))] = opt.getAttribute('data-qv-value');
        render();
        return;
      }

      var add = e.target.closest('[data-qv-add]');
      if (add && !add.disabled) {
        var v = findVariant();
        if (!v) return;
        add.disabled = true;
        add.textContent = 'Adding…';
        addToCart(v.id, 1)
          .then(function() {
            dialog.close();
            if (typeof openCart === 'function') openCart();
          })
          .catch(function(err) {
            render();
            var errEl = dialog.querySelector('#qv-error');
            if (errEl) {
              errEl.textContent = (err && (err.description || err.message)) || 'Could not add to bag. Please try again.';
              errEl.style.display = 'block';
            }
          });
      }
    };

    render();
  }

  document.addEventListener('click', function(e) {
    var trigger = e.target.closest('[data-quick-view]');
    if (!trigger) return;
    // The button sits inside the card's anchor — stop the navigation
    e.preventDefault();
    e.stopPropagation();

    var url = trigger.getAttribute('data-quick-view');
    var dialog = qvEnsure();
    dialog.innerHTML = '<div class="qv-loading eyebrow" style="opacity:0.45">Loading…</div>';
    dialog.showModal();
    document.body.style.overflow = 'hidden';

    fetch(url + '.js')
      .then(function(r) {
        if (!r.ok) throw new Error('not ok');
        return r.json();
      })
      .then(function(p) { qvRender(p, url, trigger.getAttribute('data-qv-title')); })
      .catch(function() {
        // Product JSON unavailable — fall through to the product page
        dialog.close();
        window.location.href = url;
      });
  });

  // ── Search overlay ────────────────────────────────────
  // openSearch() lives inline in header.liquid (like openCart); this
  // wires predictive results — debounced fetch of the predictive-search
  // section via the Section Rendering API, injected into the overlay.
  function initSearch() {
    var modal = document.getElementById('search-modal');
    var input = document.getElementById('search-input');
    var results = document.getElementById('predictive-results');
    if (!modal || !input || !results) return;

    var timer = null;
    var seq = 0;

    function query() {
      var q = input.value.trim();
      var mySeq = ++seq;
      if (q.length < 2) { results.innerHTML = ''; return; }
      var url = input.getAttribute('data-predictive-url') +
        '?q=' + encodeURIComponent(q) +
        '&resources[type]=product&resources[limit]=8' +
        '&resources[options][unavailable_products]=last' +
        '&section_id=predictive-search';
      fetch(url)
        .then(function(r) {
          if (!r.ok) throw new Error('not ok');
          return r.text();
        })
        .then(function(html) {
          if (mySeq !== seq) return; // a newer query is in flight
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var inner = doc.getElementById('predictive-search-results');
          results.innerHTML = inner ? inner.innerHTML : '';
        })
        .catch(function() { /* network hiccup — keep current results */ });
    }

    input.addEventListener('input', function() {
      clearTimeout(timer);
      timer = setTimeout(query, 250);
    });

    modal.addEventListener('click', function(e) {
      // Clicks on ::backdrop dispatch with the dialog itself as target
      if (e.target === modal) { modal.close(); return; }
      if (e.target.closest('[data-search-close]')) { modal.close(); return; }
      var chip = e.target.closest('[data-search-term]');
      if (chip) {
        input.value = chip.getAttribute('data-search-term');
        input.focus();
        query();
      }
    });

    document.addEventListener('keydown', function(e) {
      if ((e.metaKey || e.ctrlKey) && e.key === 'k') {
        e.preventDefault();
        if (typeof window.openSearch === 'function') window.openSearch();
      }
    });
  }

  // ── Filter dropdown toggle ────────────────────────────
  document.addEventListener('click', function(e) {
    document.querySelectorAll('.filter-dropdown').forEach(function(d) {
      if (!d.parentElement.contains(e.target)) {
        d.style.display = 'none';
      }
    });
  });

  // ── PLP card colour swatches ──────────────────────────
  // Each colourway is its own product, linked only by the
  // " - STYLE / " title segment. Cards carry an empty
  // [data-card-swatches] container; when one nears the viewport
  // we fetch its style's siblings (search.siblings view, cached
  // per style for the session) and render webshot thumbnails.
  var siblingCache = {};

  function fetchSiblings(style) {
    if (siblingCache[style]) return siblingCache[style];
    var stored = null;
    try { stored = sessionStorage.getItem('herring:sib:' + style); } catch (e) {}
    if (stored) {
      siblingCache[style] = Promise.resolve(JSON.parse(stored));
      return siblingCache[style];
    }
    siblingCache[style] = fetch('/search?view=siblings&type=product&q=' + encodeURIComponent(style))
      .then(function(r) { return r.json(); })
      .then(function(list) {
        var needle = ' - ' + style.toUpperCase() + ' / ';
        var siblings = list.filter(function(p) {
          return p.image && p.title.toUpperCase().indexOf(needle) >= 0;
        });
        // Alphabetical → the same swatch position is the same colour
        // on every card of the style.
        siblings.sort(function(a, b) { return a.title.localeCompare(b.title); });
        try { sessionStorage.setItem('herring:sib:' + style, JSON.stringify(siblings)); } catch (e) {}
        return siblings;
      });
    return siblingCache[style];
  }

  // Herring-format stores group colourways by style id: the card carries the
  // sibling handles directly (data-sibling-handles, from the _ante/_post
  // lists) and each product's webshot is fetched from its /products/<handle>.js
  // endpoint, cached for the session.
  var prodLiteCache = {};

  function fetchProductLite(handle) {
    if (prodLiteCache[handle]) return prodLiteCache[handle];
    var stored = null;
    try { stored = sessionStorage.getItem('herring:prodlite:' + handle); } catch (e) {}
    if (stored) {
      prodLiteCache[handle] = Promise.resolve(JSON.parse(stored));
      return prodLiteCache[handle];
    }
    prodLiteCache[handle] = fetch('/products/' + handle + '.js')
      .then(function(r) { return r.json(); })
      .then(function(p) {
        var img = p.featured_image
          ? p.featured_image + (p.featured_image.indexOf('?') >= 0 ? '&' : '?') + 'width=144'
          : null;
        var lite = {
          handle: p.handle,
          url: '/products/' + p.handle,
          title: p.title,
          image: img,
          available: p.available
        };
        try { sessionStorage.setItem('herring:prodlite:' + handle, JSON.stringify(lite)); } catch (e) {}
        return lite;
      });
    return prodLiteCache[handle];
  }

  // Herring titles end "… in <colour>" rather than " - <Colour>".
  function herringColour(title) {
    var i = title.lastIndexOf(' in ');
    return i >= 0 ? title.slice(i + 4).trim() : title;
  }

  function renderHerringSwatches(box, handles) {
    Promise.all(handles.map(function(h) {
      return fetchProductLite(h).catch(function() { return null; });
    })).then(function(sibs) {
      sibs = sibs.filter(function(p) { return p && p.image; });
      if (!sibs.length) return; // no live siblings — keep the card clean
      sibs.sort(function(a, b) { return a.title.localeCompare(b.title); });

      var max = 4;
      var frag = document.createDocumentFragment();
      var count = 0;

      // Own colour first, always visible
      var curImg = box.getAttribute('data-current-image');
      if (curImg) {
        var cs = document.createElement('span');
        cs.className = 'card-swatch active';
        var ci = document.createElement('img');
        ci.src = curImg;
        ci.alt = '';
        ci.width = 44;
        ci.height = 44;
        ci.loading = 'lazy';
        cs.appendChild(ci);
        frag.appendChild(cs);
        count++;
      }

      sibs.slice(0, max - count).forEach(function(p) {
        var colour = herringColour(p.title);
        var s = document.createElement('span');
        s.className = 'card-swatch';
        s.title = colour;
        s.setAttribute('data-href', p.url);
        s.setAttribute('role', 'link');
        s.setAttribute('aria-label', colour);
        s.tabIndex = 0;
        if (!p.available) s.style.opacity = '0.45';
        var img = document.createElement('img');
        img.src = p.image;
        img.alt = colour;
        img.width = 44;
        img.height = 44;
        img.loading = 'lazy';
        s.appendChild(img);
        frag.appendChild(s);
      });

      var extra = count + sibs.length - max;
      if (extra > 0) {
        var more = document.createElement('span');
        more.className = 'card-swatch-more';
        more.textContent = '+' + extra;
        frag.appendChild(more);
      }
      box.innerHTML = '';
      box.appendChild(frag);
    }).catch(function() {});
  }

  function renderCardSwatches(box) {
    var current = box.getAttribute('data-current');
    var herringHandles = box.getAttribute('data-sibling-handles');
    if (herringHandles) {
      renderHerringSwatches(box, herringHandles.split(','));
      return;
    }
    fetchSiblings(box.getAttribute('data-style')).then(function(allSiblings) {
      if (allSiblings.length < 2) return; // single colourway — nothing to offer
      // Own colour always visible: current first, alternatives after
      var siblings = allSiblings.slice();
      for (var i = 1; i < siblings.length; i++) {
        if (siblings[i].handle === current) {
          siblings.unshift(siblings.splice(i, 1)[0]);
          break;
        }
      }
      var max = 4;
      var frag = document.createDocumentFragment();
      siblings.slice(0, max).forEach(function(p) {
        var colour = p.title.split(' - ').pop().trim();
        var isCurrent = p.handle === current;
        var s = document.createElement('span');
        s.className = 'card-swatch' + (isCurrent ? ' active' : '');
        s.title = colour;
        if (!isCurrent) {
          s.setAttribute('data-href', p.url);
          s.setAttribute('role', 'link');
          s.setAttribute('aria-label', colour);
          s.tabIndex = 0;
          if (!p.available) s.style.opacity = '0.45';
        }
        var img = document.createElement('img');
        img.src = p.image;
        img.alt = colour;
        img.width = 44;
        img.height = 44;
        img.loading = 'lazy';
        s.appendChild(img);
        frag.appendChild(s);
      });
      if (siblings.length > max) {
        var more = document.createElement('span');
        more.className = 'card-swatch-more';
        more.textContent = '+' + (siblings.length - max);
        frag.appendChild(more);
      }
      box.innerHTML = '';
      box.appendChild(frag);
    }).catch(function() {});
  }

  function initCardSwatches() {
    var boxes = document.querySelectorAll('[data-card-swatches]:not([data-sw-init])');
    if (!boxes.length || !window.fetch) return;
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function(entries) {
        entries.forEach(function(en) {
          if (en.isIntersecting) {
            io.unobserve(en.target);
            renderCardSwatches(en.target);
          }
        });
      }, { rootMargin: '300px' });
      boxes.forEach(function(b) { b.setAttribute('data-sw-init', ''); io.observe(b); });
    } else {
      boxes.forEach(function(b) { b.setAttribute('data-sw-init', ''); renderCardSwatches(b); });
    }
  }

  // Swatches sit inside the card's <a>, so they navigate via JS
  // (nested anchors are invalid HTML).
  function swatchGo(e) {
    var sw = e.target.closest('.card-swatch[data-href]');
    if (!sw) return false;
    e.preventDefault();
    e.stopPropagation();
    window.location.href = sw.getAttribute('data-href');
    return true;
  }
  document.addEventListener('click', swatchGo);
  document.addEventListener('keydown', function(e) {
    if (e.key === 'Enter') swatchGo(e);
  });

  // ── Mega menu ─────────────────────────────────────────
  // Open/close is CSS-driven (:hover / :focus-within); JS adds touch
  // support, Escape, and keeps aria-expanded honest.
  function initMegaMenu() {
    var items = Array.prototype.slice.call(document.querySelectorAll('.nav-item-mega'));
    if (!items.length) return;

    function setExpanded(li, open) {
      var trigger = li.querySelector('a');
      if (trigger) trigger.setAttribute('aria-expanded', open ? 'true' : 'false');
      if (!open) li.classList.remove('is-open');
    }
    function closeAll(except) {
      items.forEach(function(li) { if (li !== except) setExpanded(li, false); });
    }

    items.forEach(function(li) {
      li.addEventListener('mouseenter', function() { setExpanded(li, true); });
      li.addEventListener('mouseleave', function() { setExpanded(li, false); });
      li.addEventListener('focusin', function() { setExpanded(li, true); });
      li.addEventListener('focusout', function(e) {
        if (!li.contains(e.relatedTarget)) setExpanded(li, false);
      });

      // Touch: first tap opens the panel, second tap follows the link
      var trigger = li.querySelector('a');
      if (trigger) {
        trigger.addEventListener('click', function(e) {
          if (!window.matchMedia('(hover: none)').matches) return;
          if (!li.classList.contains('is-open')) {
            e.preventDefault();
            closeAll(li);
            li.classList.add('is-open');
            trigger.setAttribute('aria-expanded', 'true');
          }
        });
      }
    });

    document.addEventListener('click', function(e) {
      if (!e.target.closest('.nav-item-mega')) closeAll();
    });
    document.addEventListener('keydown', function(e) {
      if (e.key !== 'Escape') return;
      closeAll();
      var el = document.activeElement;
      if (el && el.closest && el.closest('.nav-item-mega')) el.blur();
    });
  }

  // ── Mobile nav drawer ─────────────────────────────────
  function initNavDrawer() {
    var drawer = document.getElementById('nav-drawer');
    var overlay = document.getElementById('nav-overlay');
    var burger = document.querySelector('.nav-burger');
    if (!drawer || !burger) return;

    function setOpen(open) {
      drawer.classList.toggle('open', open);
      if (overlay) overlay.classList.toggle('open', open);
      burger.setAttribute('aria-expanded', open ? 'true' : 'false');
      document.body.style.overflow = open ? 'hidden' : '';
      if (open) {
        var close = drawer.querySelector('.nav-drawer__head [data-nav-close]');
        if (close) close.focus();
      }
    }

    burger.addEventListener('click', function() { setOpen(true); });
    document.addEventListener('click', function(e) {
      if (e.target.closest('[data-nav-close]')) { setOpen(false); return; }
      // Close when navigating from the drawer so it isn't open on bfcache return
      if (e.target.closest('.nav-drawer a')) setOpen(false);
    });
    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape' && drawer.classList.contains('open')) {
        setOpen(false);
        burger.focus();
      }
    });
    window.addEventListener('pageshow', function(e) {
      if (e.persisted) setOpen(false);
    });
  }

  // ── Locale selector ───────────────────────────────────
  function initLocaleSelectors() {
    document.querySelectorAll('[data-country-input]').forEach(function(input) {
      var form = input.closest('form');
      var hidden = form ? form.querySelector('[data-country-code]') : null;
      var list = input.getAttribute('list') ? document.getElementById(input.getAttribute('list')) : null;
      if (!form || !hidden || !list) return;

      var initialValue = input.value;
      var initialCode = hidden.value;
      var clear = form.querySelector('[data-country-clear]');

      function findCountry(value) {
        var target = String(value || '').trim().toLowerCase();
        if (!target) return null;

        var options = Array.prototype.slice.call(list.options);

        // Exact country-name match (e.g. "Germany")
        var exact = options.find(function(option) {
          return option.value.trim().toLowerCase() === target;
        });
        if (exact) return exact;

        // Match by ISO country code (e.g. "de", "gb")
        var byCode = options.find(function(option) {
          var code = (option.getAttribute('data-country-code') || '').trim().toLowerCase();
          return code && code === target;
        });
        if (byCode) return byCode;

        // Tolerant match: the typed value starts with a country name — covers
        // browsers that fill the input with the option's label ("Germany (EUR)")
        return options.find(function(option) {
          var name = option.value.trim().toLowerCase();
          return name && target.indexOf(name) === 0;
        }) || null;
      }

      input.addEventListener('change', function() {
        var match = findCountry(input.value);
        if (!match) {
          input.value = initialValue;
          hidden.value = initialCode;
          return;
        }

        var code = match.getAttribute('data-country-code');
        if (code && code !== hidden.value) {
          hidden.value = code;
          form.submit();
        }
      });

      input.addEventListener('focus', function() {
        input.select();
      });

      if (clear) {
        clear.addEventListener('click', function() {
          input.value = '';
          input.focus();
        });
      }
    });
  }

  //when people navigate between colours, their size selection should persist if the size is available
  // this solves the problem of people not realising their size selection changes when they change colours
  function initSizeSelectionPermanence(){

    var lastSelectedSize = localStorage.getItem('lastUserSelectedSize');

    //console.log("Last selected size was " + lastSelectedSize);

    if(lastSelectedSize != "null" && lastSelectedSize != null && lastSelectedSize != ""){

      //if there is a button with a matching data-option-value in div.size-grid, then select it
      var matchingSizeBtn = document.querySelector('div.size-grid button.size-btn[data-option-value="' + lastSelectedSize + '"]');
      
      if(matchingSizeBtn){

        //unless it's OOS
        if(!matchingSizeBtn.classList.contains('size-btn--oos')){

          //console.log("Found a matching size button, selecting it");

          matchingSizeBtn.click();

        }

      }

    }

    document.addEventListener('click', function(e) {

      var btn = e.target.closest('button.size-btn');
      if (!btn) return;

      var sizeClicked = btn.getAttribute('data-option-value');

      //console.log("Size clicked was " + sizeClicked);

      localStorage.setItem('lastUserSelectedSize', sizeClicked);

    });

  }

  // ── Page ready ────────────────────────────────────────
  function pageInit() {
    refreshCart();
    initCartPage();
    initCardSwatches();
    initMegaMenu();
    initNavDrawer();
    initLocaleSelectors();
    initSearch();
    initSizeSelectionPermanence();
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', pageInit);
  } else {
    pageInit();
  }

})();
